<template>
  <div class="modal-overlay" v-if="visible" @click.self="cancel">
    <div class="modal-card transporte-modal">
      <button class="close-btn" type="button" @click="cancel" aria-label="Cancelar">
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24"><path fill="currentColor" d="M19 6.41L17.59 5L12 10.59L6.41 5L5 6.41L10.59 12L5 17.59L6.41 19L12 13.41L17.59 19L19 17.59L13.41 12z"/></svg>
      </button>

      <p class="modal-eyebrow">Confirmar saída</p>
      <h2 class="modal-name">{{ participant?.name }}</h2>
      <div class="modal-equipe">
        <EquipeChip v-if="participant?.equipe" :equipe="participant.equipe" />
      </div>

      <PulseiraBadge v-if="participant" :acampante="participant" size="small" class="modal-pulseira" />

      <p class="modal-hint">Como o(a) acampante vai para a chácara?</p>

      <p v-if="preselected" class="modal-prefill">
        <i class="fa fa-info-circle"></i>
        <span>Pré-selecionado conforme ficha de inscrição. Confirme se está correto.</span>
      </p>

      <div class="cards">
        <button
          v-for="t in transportes"
          :key="t.value"
          type="button"
          class="transporte-card"
          :class="{
            disabled: loading && loading !== t.value,
            loading: loading === t.value,
            preselected: preselected === t.value && !loading
          }"
          :style="{ background: t.hex }"
          :aria-label="`Confirmar transporte ${t.label}`"
          :disabled="!!loading"
          @click="select(t.value)"
        >
          <div v-if="loading === t.value" class="loading-state">
            <div class="spinner"></div>
            <span>Confirmando...</span>
          </div>
          <template v-else>
            <svg v-if="t.value === 'PROPRIO'" xmlns="http://www.w3.org/2000/svg" width="64" height="64" viewBox="0 0 24 24" aria-hidden="true">
              <path fill="currentColor" d="M18.92 6.01C18.72 5.42 18.16 5 17.5 5h-11c-.66 0-1.21.42-1.42 1.01L3 12v8c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-1h12v1c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-8l-2.08-5.99zM6.5 16c-.83 0-1.5-.67-1.5-1.5S5.67 13 6.5 13s1.5.67 1.5 1.5S7.33 16 6.5 16zm11 0c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5s1.5.67 1.5 1.5s-.67 1.5-1.5 1.5zM5 11l1.5-4.5h11L19 11H5z"/>
            </svg>
            <svg v-else xmlns="http://www.w3.org/2000/svg" width="64" height="64" viewBox="0 0 24 24" aria-hidden="true">
              <path fill="currentColor" d="M4 16c0 .88.39 1.67 1 2.22V20c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-1h8v1c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-1.78c.61-.55 1-1.34 1-2.22V6c0-3.5-3.58-4-8-4s-8 .5-8 4v10zm3.5 1c-.83 0-1.5-.67-1.5-1.5S6.67 14 7.5 14s1.5.67 1.5 1.5S8.33 17 7.5 17zm9 0c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5s1.5.67 1.5 1.5s-.67 1.5-1.5 1.5zm1.5-6H6V6h12v5z"/>
            </svg>
            <span class="card-label">{{ t.label }}</span>
            <span class="card-sub">{{ t.value === 'PROPRIO' ? 'Veículo próprio' : 'Ônibus do evento' }}</span>
          </template>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import EquipeChip from './EquipeChip.vue'
import PulseiraBadge from './PulseiraBadge.vue'
import { TRANSPORTES } from '../lib/transportes'

export default {
  name: 'TransporteModal',
  components: { EquipeChip, PulseiraBadge },
  props: {
    visible: { type: Boolean, default: false },
    participant: { type: Object, default: null },
    loading: { type: String, default: null }, // 'PROPRIO' | 'ONIBUS' | null
    preselected: { type: String, default: null } // 'PROPRIO' | 'ONIBUS' | null — vem da ficha
  },
  emits: ['select', 'cancel'],
  data() { return { transportes: TRANSPORTES } },
  methods: {
    select(value) {
      if (this.loading) return
      this.$emit('select', value)
    },
    cancel() {
      if (this.loading) return
      this.$emit('cancel')
    }
  }
}
</script>

<style scoped>
.transporte-modal {
  position: relative;
  max-width: 520px;
  text-align: center;
  padding: var(--spacing-xl) var(--spacing-lg);
}
.close-btn {
  position: absolute;
  top: 12px; right: 12px;
  width: 32px; height: 32px;
  display: inline-flex; align-items: center; justify-content: center;
  background: none; border: none; cursor: pointer;
  color: var(--color-text-muted);
  border-radius: var(--radius-circle);
  transition: var(--transition-fast);
}
.close-btn:hover { background: var(--color-bg-hover); color: var(--color-text-primary); }

.modal-eyebrow {
  font-size: var(--text-xs);
  text-transform: uppercase;
  letter-spacing: 1.2px;
  color: var(--color-text-muted);
  font-weight: 700;
  margin-bottom: var(--spacing-sm);
}
.modal-name {
  font-size: var(--text-2xl);
  font-weight: 800;
  color: var(--color-text-primary);
  margin: 0 0 var(--spacing-sm);
  word-break: break-word;
}
.modal-equipe { margin-bottom: var(--spacing-md); }
.modal-pulseira { margin-bottom: var(--spacing-md); }
.modal-hint {
  font-size: var(--text-sm);
  color: var(--color-text-muted);
  margin-bottom: var(--spacing-base);
}

.cards {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: var(--spacing-md);
}

.transporte-card {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: var(--spacing-sm);
  min-height: 180px;
  padding: var(--spacing-base);
  border: 3px solid transparent;
  border-radius: var(--radius-lg);
  color: #fff;
  font-family: var(--font-primary);
  cursor: pointer;
  box-shadow: var(--shadow-button);
  transition: transform 0.15s ease-out, box-shadow 0.15s ease-out, opacity 0.2s;
}
.transporte-card:hover:not(.disabled):not(.loading) {
  transform: translateY(-3px) scale(1.02);
  box-shadow: var(--shadow-hover);
}
.transporte-card:active:not(.disabled):not(.loading) {
  transform: translateY(-1px) scale(0.99);
}
.transporte-card.disabled {
  opacity: 0.35;
  cursor: not-allowed;
  pointer-events: none;
}
.transporte-card.loading {
  cursor: progress;
}
.transporte-card.preselected {
  border-color: #fff;
  box-shadow: 0 0 0 4px rgba(255, 255, 255, 0.4), var(--shadow-hover);
  transform: scale(1.02);
}
.transporte-card.preselected::after {
  content: '✓ pré-selecionado';
  position: absolute;
  top: 8px;
  right: 12px;
  font-size: 10px;
  font-weight: 800;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  background: rgba(255, 255, 255, 0.25);
  padding: 3px 8px;
  border-radius: 999px;
}
.transporte-card { position: relative; }

.modal-prefill {
  display: flex;
  align-items: center;
  gap: 8px;
  background: #e3f2fd;
  color: #0d47a1;
  border-left: 3px solid #1976d2;
  padding: 8px 12px;
  border-radius: var(--radius-md);
  font-size: var(--text-xs);
  margin: 0 0 var(--spacing-md);
  text-align: left;
}
.card-label {
  font-size: var(--text-xl);
  font-weight: 800;
  letter-spacing: 0.5px;
}
.card-sub {
  font-size: var(--text-xs);
  opacity: 0.85;
}

.loading-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: var(--spacing-md);
  font-size: var(--text-sm);
  font-weight: 700;
}
.spinner {
  width: 36px; height: 36px;
  border: 4px solid rgba(255, 255, 255, 0.35);
  border-top-color: #fff;
  border-radius: 50%;
  animation: spin 0.7s linear infinite;
}
@keyframes spin { to { transform: rotate(360deg); } }

@media (max-width: 420px) {
  .cards { grid-template-columns: 1fr; }
  .transporte-card { min-height: 140px; }
  .card-label { font-size: var(--text-lg); }
}
</style>
